module.exports = __webpack_public_path__ + "static/media/apply-new.0e6ab10a.svg";